import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import { langReducer } from './reducers/langReducer'
import { cvReducer, competencesReducer, publicationsReducer, honorsReducer, contactReducer } from './reducers/portfolioReducers'
import { postsReducer, latestPostsReducer, postReducer, commentReducer, readLaterReducer, subscribeReducer, unsubscribeReducer } from './reducers/blogReducers'

const rootReducer = combineReducers({
  langRed: langReducer,
  cvRed: cvReducer,
  competencesRed: competencesReducer,
  publicationsRed: publicationsReducer,
  honorsRed: honorsReducer,
  contactRed: contactReducer,
  postsRed: postsReducer,
  latestPostsRed: latestPostsReducer,
  postRed: postReducer,
  commentRed: commentReducer,
  readLaterRed: readLaterReducer,
  subscribeRed: subscribeReducer,
  unsubscribeRed: unsubscribeReducer,
})

const store = configureStore({
  reducer: { rootReducer },
  middleware: [thunk],
})

export default store
